import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { ActiveMembersDialog } from "@pages/settings/subscription-settings/active-members/active-members-dialog";

/** Tooltips for each constraint type */
export const constraintTooltips: Partial<
  Record<FaroCoreApiTypes.ConstraintQuotaIdentifier, React.ReactNode>
> = {
  ["user_role"]: (
    <>
      An active member is a user with permission to make changes to a project.
      <p>
        At the workspace level, this includes all admins, group managers, and{" "}
        project managers.
      </p>
      <p>At the project level, this includes all admins and editors.</p>
      <p>
        Members who were invited to the workspace with these roles are still counted as active,{" "}
        even if their invitation status is still pending.
      </p>
    </>
  ),
  ["project_area"]: (
    <>
      Specifies the total area (in sq ft) that can be allocated to active
      projects. Archived projects are excluded from this calculation.
    </>
  ),
  ["storage"]: (
    <>
      The total amount of data space used across all projects, including both
      active and archived projects.
    </>
  ),
  ["project_count"]: (
    <>
      The total amount of active projects in the workspace, all archived
      projects are excluded from this calculation
    </>
  ),
};

/**
 * Mapping of quota identifiers to their corresponding action components.
 *
 * Each entry is a function that receives the quota object (`constraint`)
 * and returns a JSX element to render the associated action.
 */
export const constraintAction: Partial<
  Record<
    FaroCoreApiTypes.ConstraintQuotaIdentifier,
    (
      constraint: FaroCoreApiTypes.GetCompanyContext["quotas"][number]
    ) => JSX.Element
  >
> = {
  ["user_role"]: (constraint) => (
    <ActiveMembersDialog membersConstraint={constraint} />
  ),
};
